import { Injectable } from '@angular/core';

@Injectable()
export class SpecialCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello Weekly Ad");
	}
}



// WEBPACK FOOTER //
// ./src/modules/special/pages/special/special.common.ts